import axios from 'src/utils/axios';

export const GET_NOTIFICATIONS = '@notifications/get-notifications';
export const ADD_NOTIFICATIONS = '@notifications/add-notifications';
export const CLEAR_NOTIFICATIONS = '@notifications/clear-notifications';

export function getNotifications() {
  const request = axios.get('/api/notifications');

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_NOTIFICATIONS,
        payload: response.data
      })
    );
  };
}

export function addNotifications() {
  return {
    type: ADD_NOTIFICATIONS,
    payload: 1
  };
}
export function clearNotifications() {
  return {
    type: CLEAR_NOTIFICATIONS
  };
}
